import React from "react";
import "../styles/styles.css";

function AboutSection() {
  return (
    <section id="about" className="about-section">
      <div className="about-container">
        {/* Left Side: The Abstract Visual (The "Vault" Metaphor) */}
        <div className="about-visual-canvas">
          <div className="abstract-vault">
            <div className="vault-line"></div>
            {/* These shapes represent fleeting thoughts becoming permanent */}
            <div className="thought-fragment fragment-1"></div>
            <div className="thought-fragment fragment-2"></div>
            <div className="thought-fragment fragment-3"></div>
            <div className="thought-fragment fragment-4">
              <div className="pulse-dot"></div>
            </div>
          </div>
          <p className="image-caption">
            Thoughts as fragments. <br />
            <span className="italicize">Margin as the spine.</span>
          </p>
        </div>

        {/* Right Side: The Philosophy */}
        <div className="about-content">
          <div className="badge">The Philosophy</div>
          <h2 className="animated-heading">
            A library for your <br />
            <span className="italicize">inner monologue.</span>
          </h2>

          <div className="text-block">
            <p className="animated-text">
              We believe the most profound insights are often the most fleeting.
              Margin is built on a singular non-negotiable:
              <span className="text-highlight">
                capture must be faster than thinking.
              </span>
            </p>
            <p className="animated-text">
              By removing the friction of manual filing, we allow you to stay in
              the flow. Record a thought via voice or a quick text—then return
              to your reading.
            </p>
            <div className="signature-quote">
              <p className="quote-style">
                "We carry the organizational burden, so you can carry the
                wisdom."
              </p>
              <div className="quote-accent-line"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
